// @flow

/**
 * Takes the numerical components of a CSS color and converts them to a standard, 6-digit hex color
 * format.
 *
 * @param red - The red integer component of the color between 0 and 255
 * @param green - The green integer component of the color between 0 and 255
 * @param blue - The blue integer component of the color between 0 and 255
 * @return A 6-digit CSS hex color in the format #a1b2c3
 */
const getCSSHexColor = (red: number, green: number, blue: number): string => {
  const redString = red.toString(16);
  const redPrefix = redString.length === 1 ? '0' : '';
  const greenString = green.toString(16);
  const greenPrefix = greenString.length === 1 ? '0' : '';
  const blueString = blue.toString(16);
  const bluePrefix = blueString.length === 1 ? '0' : '';
  return `#${redPrefix}${redString}${greenPrefix}${greenString}${bluePrefix}${blueString}`;
};

export default getCSSHexColor;
